/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-09-14 09:37:13
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-16 17:41:39
 */
/*
 * title
 *
 *
 */

export default {
  name: 'card-content',
  props: {
    option: {
      default: () => { }
    }
  },
  render(h) {
    const { option, $dataCheck, $t } = this
    return <div>
      <div class="title">
        {option.visible ? <el-tooltip appendToBody={false} popperOptions={{ boundariesElement: option.tipTargetElemnt, gpuAcceleration: true }} manual value={option.visible} class="popover-pos" placement="top-start"  >
          <div class="info-tooltip-card" slot="content">
            {option.tooltipContent && option.tooltipContent(h, option)}
            <el-button type="text" icon="el-icon-close" onClick={() => option.tipCallback(option)} size="mini"></el-button>
          </div>
          <span style={{ color: '#8A909D' }}>{option.title}</span>

        </el-tooltip> : <span style={{ color: '#8A909D' }}>{option.title}</span>}


        {option.tooltip &&
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              <div>{option.tooltip}</div>
            </div>
            <i class="icon-a-01wenhao iconfont-el icon"></i>
          </el-tooltip>
        }
        {option.url && <a onClick="handleTo(option.url)">详情</a>}
        {option.edit && <i class="iconfont iconic-setting" onClick={option.edit}></i>}
      </div>
      {!option.noDetail ? (
        <div class="content font-manrope">
          {option.tipCallback ? (
            <span>
              {option.prefix}
              {option.count}
            </span>
          ) : (
            <el-popover placement="bottom-start" trigger="hover">
              {option.tooltipContent ? (
                <div class="card-content__popover">{option.tooltipContent(h, option)}</div>
              ) : (
                <div class="card-content__popover">
                  <div class="card-content__contentleft">
                    <div class="card-content__top">
                      {$t('system::common::current_num')}: {option.count}
                      {option.suffix}
                    </div>
                    <div>
                      {$t('system::common::statistics_days')}: {option.statisticsDays}
                    </div>
                  </div>
                  <div>
                    <div class="card-content__top">
                      {$t('system::common::last_num')}: {option.lastCount}
                    </div>
                    <div>
                      {$t('system::common::compare_result')}:
                      {option.rate !== '--' ? (
                        <span style={option.down ? 'color: #16C97B' : 'color: #F23E55'}>{option.rate}%</span>
                      ) : (
                        <span>{option.rate}%</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <span slot="reference">
                {option.prefix}
                {option.count}
              </span>
            </el-popover>
          )}
          <span style="font-size: 16px">{option.suffix}</span>
          {option.current && <span class="currency-icon">{option.current}</span>}
        </div>
      ) : (
        <div class="content font-manrope">
          <span>
            {option.prefix}
            {option.count}
          </span>
          <span style="font-size: 16px">{option.suffix}</span>
          {option.current && <span class="currency-icon">{option.current}</span>}
        </div>
      )}
    </div>
  }
}
